import {
  sendConfiguratorUserInteractionEvent,
  sendConfiguratorUserInteractionGa4Event,
} from '@utils/analytics/configuratorAnalytics'
import {
  ConfiguratorGaEventName,
  ConfiguratorType,
} from '../../ConfiguratorConfiguration/enum'
import messages from './messages'
import {
  EventActionComponentType,
  EventActionElementType,
  EventProductBrandType,
} from '@src/utils/analytics/enums'

export const CONTACT_LAB_WATER_SPECIALIST_URL =
  'campaigns/milli-q-iq7000-request-information?tfa_347=7011E000001GALgQAO'

export const CONTACT_MILLQSQ_SPECIALIST_URL =
  'campaigns/milli-q-iq7000-request-information?tfa_347=701Hn000001BmLdIAK'

export const ShoppinHelpMessages = {
  [ConfiguratorType.LabWater]: messages.LABEL_CONTACT_LAB_WATER_SPECIALIST,
  [ConfiguratorType.MilliQSq]: messages.LABEL_LAB_WATER_CONTACT_SPECIALIST,
}

export const ShoppinHelpUrls = {
  [ConfiguratorType.LabWater]: CONTACT_LAB_WATER_SPECIALIST_URL,
  [ConfiguratorType.MilliQSq]: CONTACT_MILLQSQ_SPECIALIST_URL,
}

export const ShoppinHelpPhones = {
  [ConfiguratorType.LabWater]: messages.LABEL_LAB_WATER_SPECIALIST_PHONE,
  [ConfiguratorType.MilliQSq]: messages.LABEL_MILLIQSQ_SPECIALIST_PHONE,
}

export const sendGoogleAnalyticsEvent = ({
  configuratorType,
  configuratorStepNumber,
  eventLabel,
  milliQSqEventLabel,
  participantId,
  linkUrl,
  productNumber,
}) => {
  switch (configuratorType) {
    case ConfiguratorType.LabWater:
      sendConfiguratorUserInteractionGa4Event({
        event: ConfiguratorGaEventName.Lab_Water_Configurator_Interaction,
        action: `contact specialist - step ${configuratorStepNumber}`,
        component: EventActionComponentType.Body,
        elementType: EventActionElementType.Link,
        elementText: eventLabel,
        linkUrl,
        productId: productNumber,
        productBrand: productNumber?.length
          ? EventProductBrandType.Mm
          : undefined,
      })
      break
    case ConfiguratorType.MilliQSq:
      sendConfiguratorUserInteractionEvent(
        `contact specialist - step ${configuratorStepNumber}`,
        ConfiguratorType.MilliQSq,
        configuratorStepNumber === 4 ? participantId : milliQSqEventLabel
      )
      break
    default:
      break
  }
}
